import {FreezeUI} from "./freeze-ui";
import {trackException} from "./errors";
import {Notifications} from "./notifications";

export const setModalContent = (html) => {
    const placeholderElement = document.querySelector("#modal-placeholder");
    placeholderElement.innerHTML = ""; // Clear just in case it has an old modal in it

    const modalHtml = new DOMParser().parseFromString(html, 'text/html');
    placeholderElement.append(...modalHtml.body.children);
    const modalEl = placeholderElement.querySelector(".modal");

    const modal = new bootstrap.Modal(modalEl);
    modal.show();

    return modal;
}

export const setAjaxModalContent = async url => {

    try {
        FreezeUI.Freeze();

        const {data} = await axios.get(url);

        return setModalContent(data);
    } catch (error) {
        trackException(error);
        Notifications.showError({ message: "There was a problem opening the modal." });
    } finally {
        FreezeUI.UnFreeze();
    }
}

const Modals = function () {

    const handleModalLaunchClick = async el =>{
        const url = el.href;

        await setAjaxModalContent(url);
    };

    return {
        // Public functions
        init: function () {
            document.addEventListener("click", async e => {
                const target = e.target.closest("a[data-bs-toggle=\"ajax-modal\"]")
                if (!target)
                    return;

                e.preventDefault();
                await handleModalLaunchClick(target);
            });
        }
    }
}();

export default Modals;
